"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _lurker = _interopRequireDefault(require("../../../helpers/lurker"));
var _selectors = require("../../../selectors");
var _actions = require("../../../actions");
var _platform = require("../../../helpers/platform");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ValidatingProfileMessage(_ref) {
  var partnerName = _ref.partnerName,
    currentRoomname = _ref.currentRoomname,
    listId = _ref.listId,
    toggleNotificationValidatingProfile = _ref.toggleNotificationValidatingProfile;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var isInChatList = !listId;
  function handleChange(event) {
    setChecked(event.target.checked);
    _lurker["default"].toggleNotification(currentRoomname, event.target.checked);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    flexDirection: "column",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ContentWrapper, {
      flex: "1",
      flexDirection: "column",
      justifyContent: "flex-end",
      children: [isInChatList && !_platform.isMsite && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Background, {
        src: "https://static.olx.com.br/messaging/mercurio-list-web/static/images/FakeChat.png"
      }), isInChatList && _platform.isMsite && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Background, {
        src: "https://static.olx.com.br/messaging/mercurio-list-web/static/images/FakeChatMsite.png"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.TextWrapper, {
        flexDirection: "column",
        style: {
          borderRadius: isInChatList ? '8px 8px 0px 0px' : '0px'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Icon, {
            src: "https://static.olx.com.br/messaging/mercurio-list-web/static/images/NoChatIcon.png"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.TitleMedium, {
            marginTop: "--spacing-0-5",
            marginLeft: "--spacing-1",
            children: "Uma breve pausa"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Text.BodyMedium, {
          color: "--color-neutral-130",
          marginTop: "--spacing-1",
          marginBottom: isInChatList ? '--spacing-2' : '--spacing-1',
          children: ["Estamos analisando o perfil de ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodySmall, {
            display: "inline",
            weight: "bold",
            children: partnerName
          }), "e, por seguran\xE7a, pausamos temporariamente a troca de mensagens."]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
          color: "--color-feedback-attention-110",
          weight: "bold",
          marginBottom: "--spacing-0-5",
          children: "Recomendamos pausar esta negocia\xE7\xE3o em outras plataformas at\xE9 o fim da an\xE1lise."
        })]
      })]
    }), toggleNotificationValidatingProfile && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.SwitchWrapper, {
      flexDirection: "column",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.ToggleSwitch, {
        checked: checked,
        label: "Receber notifica\xE7\xE3o sobre resultado",
        onChange: handleChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.Caption, {
        marginTop: "--spacing-1",
        marginBottom: "--spacing-1",
        children: "Tempo m\xE9dio de an\xE1lise: 24h"
      })]
    })]
  });
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentRoomname: (0, _selectors.getCurrentRoomname)(state),
    listId: (0, _selectors.getListId)(state),
    toggleNotificationValidatingProfile: (0, _selectors.toggleNotificationValidatingProfile)(state)
  };
};
ValidatingProfileMessage.propTypes = {
  partnerName: _propTypes.string.isRequired,
  currentRoomname: _propTypes.string.isRequired,
  listId: _propTypes.string.isRequired,
  toggleNotificationValidatingProfile: _propTypes.bool.isRequired
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, null)(ValidatingProfileMessage);